var csvUrl = "https://docs.google.com/spreadsheets/d/e/2PACX-1vSv6GxyjuyUS8aPucP0GcC0ar0x8zF1Uy_0liLhGgEKYafkUcLCENSxqa_N0cF196N_6ESo-Uu7xKLb/pub?gid=847800801&single=true&output=csv";

// Funkce pro získání dat z CSV
function fetchCsvData(url) {
    return $.ajax({
        url: url,
        dataType: 'text'
    });
}

// Funkce pro zpracování dat z CSV
function processCsvData(csvData) {
    var rows = csvData.split("\n");
    var keys = rows[0].split(",");
    var products = [];

    for (var i = 1; i < rows.length; i++) {
        var data = parseCsvRow(rows[i]);
        var product = {};
        for (var j = 0; j < keys.length; j++) {
            product[keys[j].trim()] = data[j] ? data[j].trim() : "";
        }
        products.push(product);
    }
    return products;
}

// Pomocná funkce pro správné zpracování řádku CSV
function parseCsvRow(row) {
    var result = [];
    var current = '';
    var insideQuotes = false;

    for (var i = 0; i < row.length; i++) {
        var char = row[i];

        if (char === '"' && !insideQuotes) {
            insideQuotes = true;
        } else if (char === '"' && insideQuotes) {
            if (row[i + 1] === '"') {
                current += '"';
                i++;
            } else {
                insideQuotes = false;
            }
        } else if (char === ',' && !insideQuotes) {
            result.push(current);
            current = '';
        } else {
            current += char;
        }
    }
    result.push(current);
    return result;
}
function loadData() {
    var storedProducts = sessionStorage.getItem('products_data');
    if (!storedProducts) {
        fetchCsvData(csvUrl).done(function(data) {
            var products = processCsvData(data);
            sessionStorage.setItem('products_data', JSON.stringify(products));
            console.log("Data byla získána a uložena do session storage.");
            matchProducts(products);
        }).fail(function() {
            console.log("Chyba při získávání dat z CSV.");
        });
    } else {
        var products = JSON.parse(storedProducts);
        console.log("Data byla načtena ze session storage.");
        matchProducts(products);
    }
}


// Function to match product codes with CSV data
function matchProducts(products) {
    if($('.id--9').length){
        $('.removeable').each(function() {
            var productSku = $(this).data('micro-sku');
            if (!productSku) {
           //     console.log("Product SKU not found.");
                return;
            }
    
            var matchedProduct = products.find(function(product) {
                return product.code == productSku;
            });
    
            if (matchedProduct) {
            //    console.log("Matched Product:", matchedProduct);
                $('.removeable[data-micro-sku="'+matchedProduct.code+'"] input.amount').attr('data-csv-step', matchedProduct.minimal)
                $('.removeable[data-micro-sku="'+matchedProduct.code+'"] .quantity').addClass('haveStep')
                var $amountInput = $('.removeable[data-micro-sku="'+matchedProduct.code+'"] .quantity .amount');
                var minVal = $amountInput.attr('data-min'),
                    maxVal = $amountInput.attr('data-max'),
                    decimalVal = $amountInput.data('decimals'),
                    minimalStep = matchedProduct.minimal;
                $('.removeable[data-micro-sku="'+matchedProduct.code+'"] .quantity-form').addClass('haveStep').prepend(
                    '<div class="toCartNew">' +
                    '<span class="minus">-</span>' +
                    '<input type="number" step="'+matchedProduct.minimal+'" data-decimals="' + decimalVal + 
                    '" data-csv-step="' + minimalStep + 
                    '" data-min="' + minVal + 
                    '" min="' + minVal + 
                    '" data-max="' + maxVal + '">' +
                    '<span class="plus">+</span></div>'
                );
    
                $('.toCartNew input').val($amountInput.val());
                $('html').on('input', '.toCartNew input', function() {
                    $amountInput.val(parseFloat($(this).val()).toFixed(1));
                });
                $('html').off('click', '.toCartNew .plus, .toCartNew .minus').on('click', '.toCartNew .plus, .toCartNew .minus', function() {
                    var $input = $(this).closest('.toCartNew').find('input'),
                        currentVal = parseFloat($input.val()),
                        step = parseFloat(minimalStep),
                        max = parseFloat($input.attr('data-max')),
                        min = parseFloat($input.attr('data-min')),
                        decimals = $input.attr('data-decimals'),
                        newVal;
                
                    if ($(this).hasClass('plus')) {
                        newVal = (currentVal + step).toFixed(decimals);
                        if (newVal > max) newVal = max;
                    } else {
                        console.log(currentVal)
                        newVal = (currentVal - step).toFixed(decimals);
                        if (newVal < min) newVal = min;
                    }

                    $input.val(parseFloat(newVal).toFixed(1)); // Zajištění jednoho desetinného místa
                    $amountInput.val(parseFloat(newVal).toFixed(1));
                    shoptet.cart.updateQuantityInCart($(this).closest('.quantity-form').find('input.amount'), 1100);
                });

                $('html').on('keydown', '.toCartNew input', function(e) {
                    if (e.key === 'Enter') {
                        e.preventDefault(); // Prevent default form behavior
                        var newValue = parseFloat($(this).val()).toFixed(1);
                        $amountInput.val(newValue).trigger('change');
                        $(this).blur(); // Remove focus from input
                    }
                });


               

                




                // Here you can add further processing of the matched product
            } else {
               // console.log("No matching product found for SKU:", productSku);
            }
        });
    }
    if($('.cart-widget-product').length){
        $('.cart-widget-product').each(function() {
            var productSku = $(this).data('micro-sku');
            if (!productSku) {
             //   console.log("Product SKU not found.");
                return;
            }
    
            var matchedProduct = products.find(function(product) {
                return product.code == productSku;
            });
    
            if (matchedProduct) {
                $(this).find('.quantity').addClass('haveStep')
                $('.cart-widget-product[data-micro-sku="'+matchedProduct.code+'"] input.amount').attr('data-csv-step', matchedProduct.minimal)
                $('.cart-widget-product[data-micro-sku="'+matchedProduct.code+'"] .quantity').addClass('haveStep')
                var $amountInput = $('.cart-widget-product[data-micro-sku="'+matchedProduct.code+'"] .quantity .amount');
                var minVal = $amountInput.attr('data-min'),
                    maxVal = $amountInput.attr('data-max'),
                    decimalVal = $amountInput.data('decimals'),
                    minimalStep = matchedProduct.minimal;
                $('.cart-widget-product[data-micro-sku="'+matchedProduct.code+'"] .quantity-form').addClass('haveStep').prepend(
                    '<div class="toCartNew">' +
                    '<span class="minus">-</span>' +
                    '<input type="number" step="'+matchedProduct.minimal+'" data-decimals="' + decimalVal + 
                    '" data-csv-step="' + minimalStep + 
                    '" data-min="' + minVal + 
                    '" min="' + minVal + 
                    '" data-max="' + maxVal + '">' +
                    '<span class="plus">+</span></div>'
                );
    
                $('.cart-widget-product[data-micro-sku="'+matchedProduct.code+'"] .toCartNew input').val($amountInput.val());
                $('html').on('input', '.cart-widget-product[data-micro-sku="'+matchedProduct.code+'"] .toCartNew input', function() {
                    $amountInput.val(parseFloat($(this).val()).toFixed(1));
                });
                $('.cart-widget-product[data-micro-sku="'+matchedProduct.code+'"]').off('click', '.toCartNew .plus, .toCartNew .minus').on('click', '.toCartNew .plus, .toCartNew .minus', function() {
                    var $input = $(this).closest('.toCartNew').find('input'),
                        currentVal = parseFloat($input.val()),
                        step = parseFloat(minimalStep),
                        max = parseFloat($input.attr('data-max')),
                        min = parseFloat($input.attr('data-min')),
                        decimals = $input.attr('data-decimals'),
                        newVal;
                
                    if ($(this).hasClass('plus')) {
                        newVal = (currentVal + step).toFixed(decimals);
                        if (newVal > max) newVal = max;
                    } else {
                        console.log(currentVal)
                        newVal = (currentVal - step).toFixed(decimals);
                        if (newVal < min) newVal = min;
                    }

                    $input.val(parseFloat(newVal).toFixed(1)); // Zajištění jednoho desetinného místa
                    $amountInput.val(parseFloat(newVal).toFixed(1));
                    shoptet.cart.updateQuantityInCart($(this).closest('.quantity-form').find('input.amount'), 1100);
                });
                
                $('html').on('keydown', '.cart-widget-product[data-micro-sku="'+matchedProduct.code+'"] .toCartNew input', function(e) {
                    if (e.key === 'Enter') {
                        e.preventDefault(); // Prevent default form behavior
                        var newValue = parseFloat($(this).val()).toFixed(1);
                        $amountInput.val(newValue).trigger('change');
                        $(this).blur(); // Remove focus from input
                    }
                });






              //  console.log("Matched Product:", matchedProduct);
                $(this).find('input.amount').attr('data-csv-step', matchedProduct.minimal)
                // Here you can add further processing of the matched product
            } else {
             //   console.log("No matching product found for SKU:", productSku);
            }
        });
    }
    if($('.product').length){
        $('.product').each(function() {
            
            var productSku = $(this).find('span[data-micro="sku"]').text().trim();
            if (!productSku) {
               // console.log("Product SKU not found.");
                return;
            }
    
            var matchedProduct = products.find(function(product) {
                return product.code == productSku;
            });
    
            if (matchedProduct) {
             //   console.log("Matched Product:", matchedProduct);
                $(this).find('input.amount').attr('data-csv-step', matchedProduct.minimal)
                // Here you can add further processing of the matched product
            } else {
              //  console.log("No matching product found for SKU:", productSku);
            }
        });
    }
    if($('.type-detail').length){
        var productSku = $('#product-detail-form meta[itemprop="sku"]').attr('content');
        if (!productSku) {
          //  console.log("Product SKU not found.");
            return;
        }

        var matchedProduct = products.find(function(product) {
            return product.code == productSku;
        });

        if (matchedProduct) {
            var $amountInput = $('.p-info-wrapper').find('.amount');
            var minVal = $amountInput.attr('data-min'),
                maxVal = $amountInput.attr('data-max'),
                decimalVal = $amountInput.data('decimals'),
                minimalStep = matchedProduct.minimal;
            if(!$('.add-to-cart .toCartNew').length){
                $('.add-to-cart').addClass('haveStep').prepend(
                    '<div class="toCartNew">' +
                    '<span class="minus">-</span>' +
                    '<input type="number" step="'+matchedProduct.minimal+'" data-decimals="' + decimalVal + 
                    '" data-csv-step="' + minimalStep + 
                    '" data-min="' + minVal + 
                    '" min="' + minVal + 
                    '" data-max="' + maxVal + '">' +
                    '<span class="plus">+</span></div>'
                );
            }   
            

            $('.p-info-wrapper .toCartNew input').val($amountInput.val());
            $('html').on('input', '.p-info-wrapper .toCartNew input', function() {
                $amountInput.val(parseFloat($(this).val()).toFixed(1));
            });
            $('.p-info-wrapper').off('click', '.toCartNew .plus, .toCartNew .minus').on('click', '.toCartNew .plus, .toCartNew .minus', function() {
                var $input = $(this).closest('.toCartNew').find('input'),
                    currentVal = parseFloat($input.val()),
                    step = parseFloat(minimalStep),
                    max = parseFloat($input.attr('data-max')),
                    min = parseFloat($input.attr('data-min')),
                    decimals = $input.attr('data-decimals'),
                    newVal;
            
                if ($(this).hasClass('plus')) {
                    newVal = (currentVal + step).toFixed(decimals);
                    if (newVal > max) newVal = max;
                } else {
                    newVal = (currentVal - step).toFixed(decimals);
                    if (newVal < min) newVal = min;
                }
                $input.val(parseFloat(newVal).toFixed(1)); // Zajištění jednoho desetinného místa
                $amountInput.val(parseFloat(newVal).toFixed(1));
            });
            $('.add-to-cart .quantity input.amount').attr('data-csv-step', matchedProduct.minimal)
        } else {
          //  console.log("No matching product found for SKU:", productSku);
        }
    }
   /* function addQuantityByMultiples(el, min, max, multiples, action) {
        var $amountInput = $(el).closest('.quantity').find('.amount');
        var value = parseFloat($amountInput.val());
        var decimal = $amountInput.attr('data-decimals')
        if (isNaN(value)) {
            return false;
        }
        var min = parseFloat(min);
        var max = parseFloat(max);
        var multiples = parseFloat(multiples);
    
        if (action === 'increase') {
            value += multiples
            value -= 1; 
            value = value.toFixed(decimal)
            //value = (parseFloat($amountInput.val())+$amountInput.data('csv-step'));
         //   console.log(value)
        } else if (action === 'decrease') {
                value -= multiples;
                value += 1;  
                value = value.toFixed(decimal)           
        }
        
       
        $amountInput.data('quantity', value);
        $amountInput.val(value)
        return true;
    }

    $('html').on('click', '.haveStep .increase', function () {
        var min = $(this).closest('.quantity').find('.amount').data('min');
        var max = $(this).closest('.quantity').find('.amount').data('max');
        var multiples = $(this).closest('.quantity').find('.amount').data('csv-step');
        addQuantityByMultiples(this, min, max, multiples, 'increase');
    });
    
    $('html').on('click', '.haveStep .decrease', function () {
        var min = $(this).closest('.quantity').find('.amount').data('min');
        var max = $(this).closest('.quantity').find('.amount').data('max');
        var multiples = $(this).closest('.quantity').find('.amount').data('csv-step');
        addQuantityByMultiples(this, min, max, multiples, 'decrease');
    });
    
    /*
    
    $(document).ready(function(){
    $('.quantity input.amount').attr('readonly','true');
    })
    
    
    document.addEventListener('ShoptetDOMContentLoaded', function() {
        $('.quantity input.amount').attr('readonly','true');
    })
    */

    
}    
    $(document).ready(function(){
        loadData();
     });

     document.addEventListener('ShoptetDOMCartContentLoaded', function () {
        loadData();
    });
